const PIXI = require('pixi.js');

module.exports = (tl, picture1, delay, duration, setLabel, inLabel, outLabel, offLabel) => {

    if (picture1.children.length < 1) return;

    const pic1Img = picture1.getChildAt(0);
    const texture = pic1Img.texture;
    if (!texture) return;
    const chImg = new PIXI.Sprite(texture);
    chImg.anchor.set(pic1Img.anchor.x, pic1Img.anchor.y);
    chImg.position.set(pic1Img.position.x, pic1Img.position.y);
    chImg.scale.set(pic1Img.scale.x, pic1Img.scale.y);

    const cm = new PIXI.filters.ColorMatrixFilter();
    cm.greyscale(0.4);
    chImg.filters = [cm];
    chImg.alpha = 0;

    picture1.addChild(chImg);

    tl.set(chImg, {alpha: 0});

    tl.to(chImg, 0, {alpha: 1}, setLabel + '+=' + 0.01);

    tl.to(chImg, duration, {alpha: 0}, setLabel + '+=' + delay);
    tl.to(chImg, 0.01, {alpha: 0}, offLabel);
}


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/AddBWImageTimelineAtStart.js